module.exports = __webpack_public_path__ + "static/media/hai-3347787.bd546646.jpg";